export const UPLOAD_SEND_PLAYLIST = 'UPLOAD_SEND_PLAYLIST'
export const UPLOAD_SEND_PLAYLIST_SUCCESS = 'UPLOAD_SEND_PLAYLIST_SUCCESS'
export const UPLOAD_SEND_PLAYLIST_FAIL = 'UPLOAD_SEND_PLAYLIST_FAIL'
export const UPLOAD_INSERT_TEMP_ITEMS = 'UPLOAD_INSERT_TEMP_ITEMS'
export const UPLOAD_REMOVE_TEMP_ITEM = 'UPLOAD_REMOVE_TEMP_ITEM'
export const UPLOAD_UPDATE_TEMP_ITEM = 'UPLOAD_UPDATE_TEMP_ITEM'
export const UPLOAD_SET_DISCO_PLAYLIST = 'UPLOAD_SET_DISCO_PLAYLIST'
export const UPLOAD_SET_DISCO_USER = 'UPLOAD_SET_DISCO_USER'
export const UPLOAD_DISCO_USER_LOGIN = 'UPLOAD_DISCO_USER_LOGIN'
export const UPLOAD_DISCO_USER_LOGIN_SUCCESS = 'UPLOAD_DISCO_USER_LOGIN_SUCCESS'
export const UPLOAD_DISCO_USER_LOGIN_FAIL = 'UPLOAD_DISCO_USER_LOGIN_FAIL'
export const UPLOAD_DISCO_USER_LOGIN_REQUIRE_MFA =
  'UPLOAD_DISCO_USER_LOGIN_REQUIRE_MFA'
